export default __webpack_public_path__ + "static/media/SJA1290.34I-38823_-22750_0.aa7dfc6c.jpg";